// 单词短语课堂任务练习类型枚举（对应 ClassroomTaskFlagEnum.WordPhrase 下的 id）
export const WordTaskTypeEnum = {
  WORD_READING: 1, // 单词朗读
  WORD_MEANING_SELECT: 2, // 看词选义
  LISTEN_WORD_SELECT: 9, // 听音选词
  LISTEN_MEANING_SELECT: 6, // 听词选义
  WORD_PK: 8, // 单词PK
  WORD_LEAD_READING: 16 // 单词领读
}
